import {createTheme, ThemeOptions} from '@mui/material';
import {hapStyles} from './hap.styles';

const premiumStyles: ThemeOptions = {
	name: 'premium',
	colors: hapStyles.colors,
	palette: {
		other: {
			planColor: '#203763',
			secondaryPlanColor: '#B79969',
		},
	},
};

const premiumTheme = createTheme(hapStyles, premiumStyles);

export {premiumStyles, premiumTheme};
